module.exports = "../images/cabin-8-person-4.jpg?v=085e1c2";